// ─── Branding ────────────────────────────────────────────────────────────────
//
// Two different things get called "the name", and conflating them is what makes
// a multi-tenant app feel wrong to its second customer:
//
//   PLATFORM brand — the product itself. Shown before anyone has signed in (the
//     login screen), and in the PWA/app-shell chrome. Identical for every firm,
//     because it is your product, not theirs.
//
//   FIRM name — the tenant the signed-in user works for. Shown in the app shell
//     after login, and on everything a client ever receives (invoices, credit
//     notes, reminder emails). Comes from that firm's own OrgSettings, falling
//     back to the Tenant record.
//
// Anything a CA firm's client sees must carry the FIRM name. Anything that
// identifies the software carries the PLATFORM brand.

/**
 * Product name. Overridable at build time via REACT_APP_PLATFORM_NAME so a
 * white-labelled deployment doesn't need a code change; defaults to today's
 * value so nothing shifts for the existing install.
 */
export const PLATFORM_NAME = process.env.REACT_APP_PLATFORM_NAME || 'MGSG Office';

/** Short form for tight spaces (sidebar mark, PWA short_name). */
export const PLATFORM_SHORT_NAME =
  process.env.REACT_APP_PLATFORM_SHORT_NAME || PLATFORM_NAME.split(/\s+/)[0];

/** Single letter for the login avatar tile. */
export const PLATFORM_INITIAL = (PLATFORM_SHORT_NAME[0] || 'M').toUpperCase();

/**
 * Where someone without an account is pointed. Accounts are created by a firm's
 * HR/Admin — there is no self-signup — so this is a request-access address, not
 * a support desk.
 */
export const ACCESS_REQUEST_EMAIL =
  process.env.REACT_APP_ACCESS_REQUEST_EMAIL || 'admin@mgsg.in';
